import axios from 'axios';

export const fetchImageNavigator = (projectId, params) => axios.get(
  `/projects/${projectId}/image_navigator`,
  {
    params
  }
);

export default {
  fetchImageNavigator
};
